import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function CopperSulfate(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual PPM?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.pre.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.initial.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento</td>

          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.growth.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Desenvolvimento</td>

          <td>
            <Input
              type="inputOnly"
              params="minerals.copperSulfate.development.ppm"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
